import { DialogDescription } from '@radix-ui/react-dialog';
import { DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { toast } from '../ui/toast/use-toast';
import { UserSimpleFinForm } from './user-simple-fin-form';
import { ScrollArea } from '@/components/ui/scroll-area';

type SetupContentProps = {
  setOpen: (open: boolean) => void;
};

export const BankImportDialogSetup = ({ setOpen }: SetupContentProps) => {
  const handleSuccess = () => {
    setOpen(false);
    toast({
      title: 'Success',
      description: 'Bank integration has been configured',
    });
  };

  return (
    <DialogContent className="max-w-xl">
      <DialogHeader>
        <DialogTitle className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
          Connect Your Bank Accounts
        </DialogTitle>
      </DialogHeader>
      <DialogDescription className="text-gray-600 dark:text-gray-400">
        Bank Import is an optional service powered by SimpleFIN that automatically imports your transactions. The
        service costs $1.50/month or $15/year. Your credentials are never stored by Liquid Budget.
      </DialogDescription>
      <ScrollArea className="max-h-[65vh] mt-2 pr-2">
        <UserSimpleFinForm onSuccess={handleSuccess} />
      </ScrollArea>
    </DialogContent>
  );
};
